import { useEffect } from "react";
import { Box, Container } from "@mui/material";
import LinearProgress from "@mui/material/LinearProgress";
import { useLocation, useNavigate } from "react-router-dom";

import ArrangementStepper from "../arrangement/ArrangementStepper";

import { useNav } from "../../context/NavProvider";
import { useAccount } from "../../context/AccountProvider";
import { useArrangement } from "../../context/ArrangementProvider";
import { useSfs } from "../../context/SfsProvider";
import { useAnalytics } from "../../context/AnalyticsProvider";
import { ANALYTICS_TAGS } from "../../constants/analyticsTags";

/**
 * Arrangement page component
 * @returns
 */
function ArrangementPage() {

  const { setShowFooter } = useNav();
  setShowFooter(false);

  const { useGetAccount } = useAccount();
  const location = useLocation();

  const {
    useGetSfs,
    loadSfsData,
    sfsLoaded,
    disposableIncome,
    monthsSinceReview,
  } = useSfs();

  const {
    useGetArrangement,
    loadPlanData,
    planLoaded,
    lastSavedPlan
  } = useArrangement();

  const { account, isAccountLoading } = useGetAccount();
  const { sfs, isSfsLoading } = useGetSfs();
  const { arrangement, isArrangementLoading } = useGetArrangement();
  const { setTag } = useAnalytics();
  const navigate = useNavigate();

  useEffect(() => {
    // Redirect to SFS page if low DI, out of date review,
    // or DI lower than smallest possible monthly payments
    if (
      !isSfsLoading && sfsLoaded && !isArrangementLoading && planLoaded && !isAccountLoading &&
      (((monthsSinceReview === null || monthsSinceReview >= 6) || disposableIncome < 1) ||
      (account?.arrearsAmount/12 > disposableIncome))
    ) {
      navigate("/sfs");
    } else if (!isSfsLoading && sfsLoaded && !isArrangementLoading && planLoaded && !isAccountLoading) {
        setTag(ANALYTICS_TAGS.PPLAN_STARTED, { path: location.pathname });
    }
  }, [disposableIncome, setTag]);


  useEffect(() => {
    // Only load plan when arrangement & DI have loaded to support calculations
    if (
      !isAccountLoading &&
      !isArrangementLoading &&
      !planLoaded &&
      sfsLoaded &&
      disposableIncome
    ) {
      loadPlanData(arrangement);
    }

    if (!sfsLoaded && !isSfsLoading) {
      loadSfsData(sfs);
    }
  }, [
    planLoaded,
    isSfsLoading,
    sfsLoaded,
    isArrangementLoading,
    loadPlanData,
    loadSfsData,
    arrangement,
    sfs,
  ]);

  if (
    isAccountLoading ||
    isSfsLoading ||
    isArrangementLoading
  ) {
    return <LinearProgress />;
  }

  return (
    lastSavedPlan &&
    account &&
    planLoaded &&
    sfsLoaded &&
    disposableIncome >= 1 && (
      <>
        <Container sx={{ mt: 4, mb: 7, paddingBottom: "350px" }}>
          <Box>
            <ArrangementStepper />
          </Box>
        </Container>
        {setShowFooter(true)}
      </>
    )
  );
}

export default ArrangementPage;
